export const convertGoogleDriveUrl = (url: string): string => {
  if (!url) return '';
  
  // Check if it's a Google Drive URL
  const driveMatch = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/);
  
  if (driveMatch && driveMatch[1]) {
    // Use lh3.googleusercontent.com which bypasses CORS issues
    // This works for publicly shared Google Drive images
    return `https://lh3.googleusercontent.com/d/${driveMatch[1]}`;
  }
  
  // Return original URL if not a Google Drive link
  return url;
};